import AES from '@ali/aes-tracker';
import util from './utils/util';
import libs from './libs';
import { setGlobal } from './utils/global';
setGlobal('AES', AES);
var sendError = libs.sendError,
    processError = libs.processError,
    processUnhandledRejection = libs.processUnhandledRejection;

(function () {
  var config = AES.getConfig('plugin_jserror') || {};

  if (!window || window.AESPluginJsError) {
    return;
  }

  util.on(window, 'error', processError);
  !config.disable_unhandled_rejection && util.on(window, 'unhandledrejection', processUnhandledRejection);
})();

export { sendError };
export default {
  sendError: sendError
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-jserror@1.0.13@@ali/aes-tracker-plugin-jserror/es/index.js
// module id = null
// module chunks = 